import * as React from "react";
import {
  ProductsTabKey,
  takePendingOpenProductId,
} from "app/shared/products/openProductNavigation";

export function useAutoOpenProductModal(
  productTab: ProductsTabKey,
  openProduct: (id: number) => void
): void {
  const openProductRef = React.useRef(openProduct);
  openProductRef.current = openProduct;

  React.useLayoutEffect(() => {
    const productId = takePendingOpenProductId(productTab);
    if (productId != null) {
      openProductRef.current(productId);
    }
  }, [productTab]);
}